
import { ServiceCategory } from '@/types/serviceTypes';

export const hardscapingCategory: ServiceCategory = {
  id: 'hardscaping',
  name: 'Hardscaping & Construction',
  icon: 'hardscape',
  services: [
    {
      id: 'masonry',
      title: 'Masonry',
      description: 'Create lasting beauty with our expert masonry services, from decorative walls to functional structures that enhance your property.',
      features: [
        'Retaining walls',
        'Decorative stonework',
        'Brick pathways',
        'Custom fire pits',
        'Stone patios and steps'
      ],
      image: 'https://images.unsplash.com/photo-1617720356637-6264c1c0b4bb?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'custom-stonework',
      title: 'Custom Stonework',
      description: 'Elevate your landscape with premium stonework tailored to your property\'s unique style and your personal preferences.',
      features: [
        'Natural stone installation',
        'Custom stone features',
        'Veneer applications',
        'Drystack techniques',
        'Artistic stone arrangements'
      ],
      image: 'https://images.unsplash.com/photo-1562516500-c0b05c5c14a2?q=80&w=2069&auto=format&fit=crop'
    },
    {
      id: 'fence-work',
      title: 'Fence Work',
      description: 'Enhance security, privacy, and aesthetics with our custom fencing solutions designed to complement your landscape.',
      features: [
        'Wood fence installation',
        'Vinyl fencing options',
        'Ornamental metal fences',
        'Privacy screening',
        'Fence repair services'
      ],
      image: 'https://images.unsplash.com/photo-1618090584624-77c9035e3681?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'hardscape-projects',
      title: 'Hardscape Projects',
      description: 'Transform your outdoor living space with custom hardscape elements that add both beauty and functionality to your property.',
      features: [
        'Paver patios and walkways',
        'Outdoor kitchens',
        'Water features',
        'Pergolas and gazebos',
        'Seating walls and steps'
      ],
      image: '/lovable-uploads/c9bab5be-8111-40c6-ae6f-a50a0408b536.png'
    }
  ]
};
